import React from 'react';
import WindowedSelect from 'react-windowed-select';
import { ClipLoader } from 'react-spinners';
import { selectStyles } from '../leaseGeneralInvoiceReceipt/formUtils';
import { fmt3 } from './reverseHelpers';

const selectProps = { menuPortalTarget: document.body, menuPlacement: 'auto', menuShouldScrollIntoView: false, styles: selectStyles };

const Field = ({ label, loading, children, width = 260 }) => (
    <div className="d-flex align-items-center gap-2">
        <label className="form-label mb-0" style={{ minWidth: 70 }}>{label}</label>
        <div style={{ width }}>{children}</div>
        {loading && <ClipLoader size={16} color="#6c5ce7" />}
    </div>
);

/**
 * @param {{
 *   properties: object[], units: object[], leaseNos: object[],
 *   property: object|null, unit: object|null, leaseNo: object|null, showAll: boolean, receiptNo: string, totalPaid: number|null,
 *   loading: { dropdowns: boolean, units: boolean, leaseNos: boolean, lines: boolean },
 *   disabled: boolean,
 *   onProperty: Function, onUnit: Function, onLeaseNo: Function, onShowAll: Function,
 *   onReceiptNoChange: Function, onReceiptNoCommit: Function
 * }} props
 */
const SearchPanel = ({
    properties, units, leaseNos, property, unit, leaseNo, showAll, receiptNo, totalPaid, loading, disabled,
    onProperty, onUnit, onLeaseNo, onShowAll, onReceiptNoChange, onReceiptNoCommit,
}) => (
    <div className="cost-center-section mt-3">
        <div className="d-flex slide-header"><div className="param-label pt-1">Search</div></div>
        <div className="border-box2 p-3">
            <div className="d-flex flex-wrap align-items-center gap-4">
                <Field label="Property" loading={loading.dropdowns} width={300}>
                    <WindowedSelect
                        {...selectProps}
                        isClearable
                        isDisabled={disabled}
                        placeholder="--Select--"
                        value={property}
                        options={properties}
                        onChange={onProperty}
                    />
                </Field>
                <Field label="Unit No" loading={loading.units} width={180}>
                    <WindowedSelect
                        {...selectProps}
                        isClearable
                        isDisabled={disabled || !property}
                        placeholder="--Select--"
                        value={unit}
                        options={units}
                        onChange={onUnit}
                    />
                </Field>
                <Field label="Lease No" loading={loading.leaseNos} width={200}>
                    <WindowedSelect
                        {...selectProps}
                        isClearable
                        isDisabled={disabled}
                        placeholder="--Select--"
                        value={leaseNo}
                        options={leaseNos}
                        onChange={onLeaseNo}
                    />
                </Field>
                <label className="d-flex align-items-center gap-2 mb-0">
                    <input type="checkbox" checked={showAll} disabled={disabled} onChange={(e) => onShowAll(e.target.checked)} />
                    Show all leases
                </label>
            </div>
            <div className="d-flex flex-wrap align-items-center gap-4 mt-3">
                <Field label="Receipt No" width={200}>
                    <input
                        type="text"
                        className="p-2 form-control"
                        disabled={disabled}
                        value={receiptNo}
                        onChange={(e) => onReceiptNoChange(e.target.value)}
                        onBlur={onReceiptNoCommit}
                        onKeyDown={(e) => { if (e.key === 'Enter') onReceiptNoCommit(); }}
                    />
                </Field>
                <div className="d-flex align-items-center gap-2">
                    <span>Total Paid on Lease:</span>
                    <strong>{totalPaid === null || totalPaid === undefined ? '' : fmt3(totalPaid)}</strong>
                </div>
            </div>
        </div>
    </div>
);

export default SearchPanel;
